export default __webpack_public_path__ + "static/media/1944.c2b009e4.png";